import React from "react";
import { useTranslation } from "react-i18next";
import "./top-up-sum.scss";
import ShowContainer from "../../../mui/ShowContainer";

export default function TopUpSum({ value, currency, percent, setStep }) {
  const getRounded = (num) => Math.floor(num * 100) / 100;

  const { t } = useTranslation();
  // const valueForPercent = (value - (value * percent) / 100).toFixed(2);
  const valueForPercent = getRounded(value - value * (percent / 100));

  return (
    <div className="top-up-balance__select">
      <div className="top-up-select__content-container">
        <div className="top-up-select__content">
          <div className="top-up-select__data">
            <div className="top-up-select__gradient" />
            <span className="top-up-select__value"> {value}</span>
            <div className="top-up-select__currency"> {currency}</div>
            <button onClick={() => setStep(1)} className="top-up-select__change">
              {t("Change amount")}
            </button>
          </div>
          <ShowContainer condition={valueForPercent && valueForPercent != value}>
            <div className="top-up-select__info">
              {t("taking into account the commission you will receive", {
                percent,
                value: valueForPercent,
                currency
              })}
            </div>
          </ShowContainer>
        </div>
      </div>
    </div>
  );
}
